import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const AlertBox = ({ open, handleClose, handleConfirm, title, disabled = false }) => {
  return (
    <>
      <Dialog
        PaperProps={{
          style: {
            width: '350px',
            maxWidth: 'xs',
          },
        }}
        fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <WarningIcon sx={{ marginRight: '8px', color: '#f0ad4e', fontSize: '40px' }} />
        </DialogTitle>
        <DialogContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <DialogContentText id="alert-dialog-description">{title}</DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '10px',
          }}
        >
          <Button
            sx={{ marginRight: '10px' }}
            onClick={handleClose}
            color="secondary"
            variant="contained"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            autoFocus
            color="primary"
            disabled={disabled}
            variant="contained"
          >
            {disabled ? 'Loading' : 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AlertBox;
